import { useState } from 'react';

import { useResumeSubscription } from '@bpm-web-app/swr-hooks';
import { showToast, useApiErrorHandler } from '@bpm-web-app/utils';
import { usePlatform } from '../../../helpers/usePlatform';

export const useResume = () => {
    const [isConfirmationOpen, setConfirmationOpen] = useState(false);
    const platform = usePlatform();
    const errorHandler = useApiErrorHandler();
    const { resumeSubscription, isLoading } = useResumeSubscription(platform, {
        onSuccess: () => {
            setConfirmationOpen(false);
            showToast({
                type: 'success',
                title: 'The subscription has been successfully resumed',
            });
        },
        onError: (error) => {
            errorHandler({ error });
        },
    });

    return {
        isConfirmationOpen,
        setConfirmationOpen,
        resumeSubscription,
        isLoading,
        platform: platform as typeof platform,
    };
};
